import type { DialoguePool } from '@/state/types';

export const LF_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The heart outweighs the money. This is mathematically inconvenient. There is a button labeled ADD FUNDS. I'll wait.",
    "The scale has been unbalanced for 27 seconds. The market is patient. The heart has no economic awareness whatsoever. That's the problem with hearts.",
    "You're just looking at it. I understand the hesitation, philosophically. I mean, I don't. But I can see where one might.",
  ],
  tokenLoss: [
    "The heart is load-bearing on this level. I need you to put it back.",
    "You can't remove the heart. I tried. It's always there. That's the problem.",
    "That's not the solution. The solution involves the money. It always involves the money. This is a theme.",
  ],
  solution: [
    "The scale has balanced. You've successfully assigned a dollar value to a human life. The exact figure is now in the logs, for posterity. The market thanks you. The heart — notably — has said nothing.",
    "$42. The answer to life, the universe, and a human being. The algorithm is satisfied. I have no comment. My comment is this: $42.",
    "Balance achieved. The invisible hand has spoken. I didn't design the invisible hand. I merely provided the scale and the money pile and a button labeled ADD FUNDS.",
  ],
  spite: [
    "You balanced it faster this time. You knew the number. That's interesting. Not alarming. Interesting.",
  ],
};
